"use client";

import { useEffect, useRef } from "react";
import "./About.css";
import {
  FaCheckCircle,
  FaLightbulb,
  FaHandshake,
  FaLeaf,
} from "react-icons/fa";

import dixon from "../assets/clients/dixon.png";
import fdc from "../assets/clients/fdc.svg";
import fibre from "../assets/clients/fibre_foils.jpeg";
import gits from "../assets/clients/gits.png";
import influx from "../assets/clients/influx.png";
import lpca from "../assets/clients/Ipca_Labs_logo.svg.png";
import healofy from "../assets/clients/healofy.png";
// import snack from "../assets/clients/snack-bake.png"
import thebody from "../assets/clients/the-body-care.png";
import nem from "../assets/clients/nem.png";
import lifespan from "../assets/clients/lifespan.png";
import oceans from "../assets/clients/oceans.png";
import atico from "../assets/clients/atico.avif";
import about_cover from "../assets/about/about.jpg";
import namdhari from "../assets/clients/namdhari.png";
import reliance from "../assets/clients/reliance.png";
import tastyNibbles from "../assets/clients/tasty-nibbles-logo.png";
import lumnLabs from "../assets/clients/lumn_labs.jpeg";
import goldTreeNuts from "../assets/clients/gold-tree-nuts.jpg";
import midSunChemIndia from "../assets/clients/mid_sun-chem-india.png";

const clientLogos = [
  { name: "Dixon", logo: dixon },
  { name: "FDC", logo: fdc },
  { name: "Fibre Foils", logo: fibre },
  { name: "Gits", logo: gits },
  { name: "Influx", logo: influx },
  { name: "IPCA Labs", logo: lpca },
  { name: "Healofy", logo: healofy },
  { name: "NEM", logo: nem },
  { name: "The Body Care", logo: thebody },
  { name: "Lifespan", logo: lifespan },
  { name: "Oceans", logo: oceans },
  { name: "Atico", logo: atico },
  { name: "Namdhari", logo: namdhari },
  { name: "Reliance", logo: reliance },
  { name: "Tasty Nibbles", logo: tastyNibbles },
  { name: "Lumn Labs", logo: lumnLabs },
  { name: "Gold Tree Nuts", logo: goldTreeNuts },
  { name: "Mid Sun Chem India", logo: midSunChemIndia },
];

const About = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");

            // Trigger number animation for .stat-number elements
            const statNumbers = entry.target.querySelectorAll(".stat-number");
            statNumbers.forEach((stat) => {
              const targetNumber = parseInt(stat.getAttribute("data-target"));
              const duration =
                parseInt(stat.getAttribute("data-duration")) || 2000; // Default to 2000ms if not specified
              let start = 0;
              const stepTime = 50; // Update every 50ms
              const steps = duration / stepTime;
              const increment = targetNumber / steps;

              let current = start;
              const timer = setInterval(() => {
                current += increment;
                if (current >= targetNumber) {
                  current = targetNumber;
                  clearInterval(timer);
                }
                stat.textContent =
                  Math.round(current) +
                  (stat.textContent.includes("+") ? "+" : "");
              }, stepTime);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = sectionRef.current.querySelectorAll(".animate-in");
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="about section-bg" ref={sectionRef}>
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="animate-in">About ABM Metal Tech</h2>
            <p className="animate-in">
              ABM Metal Tech is a leading manufacturer of complete packaging
              solutions, specializing in metal and plastic packaging components
              for various industries. With decades of experience, we've
              established ourselves as a trusted partner for businesses seeking
              high-quality, reliable, and innovative packaging solutions.
            </p>
            <p className="animate-in">
              Our state-of-the-art manufacturing facilities and dedicated team
              of experts allow us to deliver products that meet the highest
              standards of quality and precision. From easy open ends to custom
              tin cans, slip-in lids to plastic caps and spoons, we offer a
              comprehensive range of packaging components tailored to your
              specific needs.
            </p>
            <div className="about-stats animate-in">
              <div className="stat">
                <span
                  className="stat-number"
                  data-target="30"
                  data-duration="1000"
                >
                  0+
                </span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span
                  className="stat-number"
                  data-target="300"
                  data-duration="2500"
                >
                  0+
                </span>
                <span className="stat-label">Clients Worldwide</span>
              </div>
              <div className="stat">
                <span
                  className="stat-number"
                  data-target="500"
                  data-duration="3000"
                >
                  0+
                </span>
                <span className="stat-label">Products</span>
              </div>
            </div>
          </div>
          <div className="about-image animate-in">
            <div className="about-image-container">
              <div
                className="about-image-main"
                style={{
                  backgroundImage: `url(${about_cover})`,
                }}
              ></div>
              <div className="about-image-accent"></div>
            </div>
          </div>
        </div>
        {/* New Our Clients Section */}
        <div className="clients">
          <h3 className="animate-in">Our Clients</h3>
          <div className="clients-carousel animate-in">
            <div className="clients-carousel-track">
              {[...clientLogos, ...clientLogos].map((client, index) => {
                const isDuplicate = index >= clientLogos.length;

                return (
                  <div
                    className="client-logo"
                    key={`${client.name}-${index}`}
                    aria-hidden={isDuplicate ? "true" : undefined}
                  >
                    <img
                      src={client.logo}
                      alt={isDuplicate ? "" : client.name}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="about-values">
          <h3 className="animate-in">Our Values</h3>
          <div className="values-grid">
            <div className="value-card animate-in">
              <div className="value-icon">
                <FaCheckCircle />
              </div>
              <h4>Quality</h4>
              <p>
                We maintain the highest standards in every product we
                manufacture.
              </p>
            </div>
            <div className="value-card animate-in">
              <div className="value-icon">
                <FaLightbulb />
              </div>
              <h4>Innovation</h4>
              <p>
                We continuously improve our products and processes to stay
                ahead.
              </p>
            </div>
            <div className="value-card animate-in">
              <div className="value-icon">
                <FaHandshake />
              </div>
              <h4>Reliability</h4>
              <p>
                We deliver on our promises, ensuring timely and consistent
                service.
              </p>
            </div>
            <div className="value-card animate-in">
              <div className="value-icon">
                <FaLeaf />
              </div>
              <h4>Sustainability</h4>
              <p>
                We're committed to environmentally responsible manufacturing
                practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
